import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'
import moment from 'moment'

import config from '../../../../../../../../config'

import { BLOCK_DATA_LOADED } from '../../../../../../components/Workspace/components/HocBlock/constants'
import {
    blockSaveCustomData,
    blockDataTransformed,
} from '../../../../../../components/Workspace/components/HocBlock/actions'

import {
    PAYMENT_INDEX_CHART_TOGGLE_SELECTOR,
    PAYMENT_INDEX_CHART_TOGGLE_DATA_TABLE,
    PAYMENT_INDEX_TOGGLE_TERMINOLOGY,
} from './constants'

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.paymentIndex.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const data = _action?.data?.data
    const transformedData = {
        summary: {
            legend: data?.[0]?.legend,
            summary: data?.[0]?.summary,
        },
        chart: {
            data: {
                year: _.reduce(
                    data?.[1]?.data,
                    (acc, val) => [
                        ...acc,
                        {
                            startDate: moment(_.get(val, 'startDate.value', null)).format('DD-MM-YYYY'),
                            index: _.get(val, `year.paymentIndex.value`, null),
                            sectorIndex: _.get(val, `year.sector.value`, null),
                            numberOfInvoices: _.get(val, `year.invoiceCount`, 0),
                            totalAmountOfInvoices: _.get(val, `year.totalAmount.amount`, 0),
                            numberOfSuppliers: _.get(val, `year.supplierCount`, 0),
                            currency: _.get(val, `year.totalAmount.currency`, 'CZK'),
                        },
                    ],
                    []
                ),
                quarter: _.reduce(
                    data?.[1]?.data,
                    (acc, val) => [
                        ...acc,
                        {
                            startDate: moment(_.get(val, 'startDate.value', null)).format('DD-MM-YYYY'),
                            index: _.get(val, `quarter.paymentIndex.value`, null),
                            sectorIndex: _.get(val, `quarter.sector.value`, null),
                            numberOfInvoices: _.get(val, `quarter.invoiceCount`, 0),
                            totalAmountOfInvoices: _.get(val, `quarter.totalAmount.amount`, 0),
                            numberOfSuppliers: _.get(val, `quarter.supplierCount`, 0),
                            currency: _.get(val, `quarter.totalAmount.currency`, 'CZK'),
                        },
                    ],
                    []
                ),
            },
        },
        breakdown: data?.[2]?.breakdown,
    }

    yield put(blockDataTransformed(module, id, blockKey, transformedData))

    yield put(
        blockSaveCustomData(module, id, blockKey, {
            selector: 'year',
            chartDataTableActive: false,
        })
    )

    return null
}

function* paymentIndexChangeCustomData(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.paymentIndex.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = _.get(action, 'data.customData', null)

    yield put(blockSaveCustomData(module, id, blockKey, customData))

    return null
}

export default function* blockTransformSaga() {
    yield all([
        takeEvery(BLOCK_DATA_LOADED, onDataLoaded),
        takeEvery(PAYMENT_INDEX_TOGGLE_TERMINOLOGY, paymentIndexChangeCustomData),
        takeEvery(PAYMENT_INDEX_CHART_TOGGLE_SELECTOR, paymentIndexChangeCustomData),
        takeEvery(PAYMENT_INDEX_CHART_TOGGLE_DATA_TABLE, paymentIndexChangeCustomData),
    ])
}
